import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Modal} from "react-bootstrap";
import Moment from "react-moment";

class ConfirmAcceptanceModal extends Component {
    static propTypes = {
        data: PropTypes.object,
        onConfirm: PropTypes.func,
        onHide: PropTypes.func.isRequired
    };
    static defaultProps = {};
    state = {};

    render() {
        const {data, onConfirm, onHide, ...props} = this.props;
        return (
            <Modal {...props} className="modal-alert modal-warning" bsSize="small">
                <Modal.Header>
                    <i className="fa fa-question-circle"/>
                </Modal.Header>
                <Modal.Body>
                    <h5>Отправка заявки на участие</h5>
                    {
                        data &&
                        <p>
                            Вы отправляете заявку на участие в тендере (дата доставки: <b><Moment locale="ru" format="DD.MM.YYYY">{data.deliveryDate}</Moment></b>):
                            <br/>
                            {
                                data.items.map((tri, i) => {
                                    const price = (tri.providerRate || (data.taxTypeId === 1 ? tri.proposedRateWithTax : tri.proposedRateWithoutTax))
                                        .toLocaleString("ru-ru", { maximumFractionDigits: 2, style: "currency", currency: "rub" })
                                        .replace("₽", "р.");

                                    return (
                                        <div>
                                            {i !== 0 && <br/>}
                                            {i !== 0 && <br/>}
                                            <span>
                                                <b>"{tri.name}"</b> {tri.count} шт.
                                                <br/>
                                                Ваша ставка <b>{price} {data.taxTypeId === 1 ? "с НДС" : "без НДС"}</b>
                                            </span>
                                        </div>
                                    );
                                })
                            }
                        </p>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-success"
                            onClick={() => { onConfirm(); onHide(); }}>
                        Подтверждаю
                    </button>
                    <button type="button" className="btn"
                            onClick={() => onHide()}>
                        Отмена
                    </button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default ConfirmAcceptanceModal;


// WEBPACK FOOTER //
// ./src/pages/TenderBlock/TenderRequests/modals/ConfirmAcceptanceModal.js